import { IGetGestaoDistribuicaoEpiByIdUseCase } from "../../../presentation/useCases/read/get_gestao_distribuicao_epi_by_id_use_case";
import { GestaoDistribuicaoEpi } from "../../models/gestao_distribuicao_epi";
import { IGestaoEpiRepository } from "../../repositories/gestao_epi_repository";

/**
 * GetGestaoDistribuicaoEpiByIdUseCase
 */

export class GetGestaoDistribuicaoEpiByIdUseCase implements IGetGestaoDistribuicaoEpiByIdUseCase {
  constructor(private readonly repository: IGestaoEpiRepository) { }

  async getGestaoDistribuicaoEpiById(
    idGestaoDistribuicaoEpi: number,
  ): Promise<GestaoDistribuicaoEpi> {
    const result = await this.repository.getGestaoDistribuicaoEpiById(idGestaoDistribuicaoEpi);
    if (result === null) throw new Error('Falha ao buscar distribuição de epi!');
    return result;
  }
}
